import { render, staticRenderFns } from "./host.vue?vue&type=template&id=0ac99aed&scoped=true"
import script from "./host.vue?vue&type=script&lang=js"
export * from "./host.vue?vue&type=script&lang=js"
import style0 from "./host.vue?vue&type=style&index=0&id=0ac99aed&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac99aed",
  null
  
)

export default component.exports